import { render, staticRenderFns } from "./DangerBloc.vue?vue&type=template&id=6d7a01f8"
import script from "./DangerBloc.vue?vue&type=script&lang=js"
export * from "./DangerBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports